import { SVGProps } from "react";

const KpiStarIcon = ({
  width = 20,
  height = 20,
  color = "#EA8C00",
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18.0264 17.2514"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.59238 0.886591C8.76451 0.537803 9.26187 0.537803 9.43401 0.886591L11.6623 5.40169C11.7307 5.5402 11.8628 5.6362 12.0157 5.65841L16.9984 6.38244C17.3833 6.43837 17.537 6.91139 17.2585 7.18288L13.653 10.6974C13.5424 10.8052 13.4919 10.9605 13.518 11.1128L14.3691 16.0754C14.4349 16.4587 14.0325 16.751 13.6882 16.5701L9.23157 14.227C9.09486 14.1552 8.93153 14.1552 8.79482 14.227L4.33815 16.5701C3.99387 16.751 3.5915 16.4587 3.65725 16.0754L4.5084 11.1128C4.53451 10.9605 4.48404 10.8052 4.37344 10.6974L0.767912 7.18288C0.489388 6.91139 0.643081 6.43837 1.02799 6.38244L6.0107 5.65841C6.16355 5.6362 6.29568 5.5402 6.36404 5.40169L8.59238 0.886591Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.03192 0.609988C8.43331 -0.203329 9.59308 -0.203329 9.99447 0.609988L12.1866 5.05168L17.0883 5.76393C17.9858 5.89436 18.3442 6.99735 17.6947 7.63044L14.1478 11.0878L14.9851 15.9697C15.1385 16.8636 14.2002 17.5453 13.3974 17.1233L9.01319 14.8183L4.62899 17.1233C3.82619 17.5453 2.88793 16.8636 3.04124 15.9697L3.87855 11.0878L0.331655 7.63044C-0.317818 6.99736 0.0405696 5.89436 0.938118 5.76393L5.83981 5.05168L8.03192 0.609988ZM9.01319 1.44614L6.9245 5.6783C6.7651 6.00127 6.45699 6.22512 6.10058 6.27691L1.43012 6.95557L4.80969 10.2498C5.0676 10.5012 5.18529 10.8634 5.1244 11.2184L4.32659 15.87L8.50398 13.6738C8.82277 13.5062 9.20362 13.5062 9.52241 13.6738L13.6998 15.87L12.902 11.2184C12.8411 10.8634 12.9588 10.5012 13.2167 10.2498L16.5963 6.95557L11.9258 6.27691C11.5694 6.22512 11.2613 6.00127 11.1019 5.6783L9.01319 1.44614Z"
      fill={color}
    />
  </svg>
);

export default KpiStarIcon;
